import { Chakra } from "@airhelp/react-ui-components";
import { useTranslations, useLocalizedData } from "contexts/LocalizationContext/hooks";
import { useModal } from "contexts/ModalContext";
import { TrustpilotSummary } from "modules/common/components/Trustpilot";
import Grid from "modules/common/components/Grid";
import Modal from "modules/help-a-friend/components/Modal";
import { trackEvents } from "utils/trackingUtils";
import { SHARE_NOW_HERO_GTM, SHARE_NOW_HERO_MP } from "modules/help-a-friend/trackingConsts";
import config from "config/config";
import { useReferralProgramConfig } from "contexts/DataContext/hooks";
import HeroCard from "./HeroCard";

const { Box, Button, Heading, Image, Text, Flex, useToken } = Chakra;

const Hero = () => {
  const translations = useTranslations();
  const { getCompensationValue } = useLocalizedData();
  const { openModal } = useModal();
  const [primary900, white] = useToken("colors", ["primary.900", "white"]);
  const [lg, xl5] = useToken("fontSizes", ["lg", "5xl"]);
  const localizedCompensationValue = getCompensationValue("compensation", "EUR");
  const referralProgramConfig = useReferralProgramConfig();
  const { commissionValue } = referralProgramConfig;

  const clickHandler = () => {
    openModal(<Modal />, "lg");
    trackEvents({ gtmEvent: SHARE_NOW_HERO_GTM, mixpanelEvent: SHARE_NOW_HERO_MP });
  };

  const svgContentConfig = [
    {
      id: 1,
      position: { fromLeft: 305, fromTop: 93 },
      styles: { fill: primary900, fontSize: xl5, fontWeight: "bold" },
      value: `€${commissionValue}`,
    },
    {
      id: 2,
      position: { fromLeft: 324, fromTop: 218 },
      styles: { fill: primary900, fontSize: lg, fontWeight: "bold", letterSpacing: "2px" },
      value: `12/${(new Date().getFullYear() + 3).toString().substr(2)}`,
    },
    {
      id: 3,
      position: { fromLeft: 71, fromTop: 218 },
      styles: { fill: white, fontSize: lg, fontWeight: "bold", letterSpacing: "2px" },
      value: "Michelle Smith",
    },
  ];

  return (
    <Box overflowX="hidden" mt={20}>
      <Grid mt={12}>
        <Box gridColumn={{ base: "initial", md: "span 6", lg: "span 5" }} alignSelf="center">
          <TrustpilotSummary />
          <Heading data-testid="hero-heading" variant="h1" as="h1" my={4}>
            {translations("hero_heading", { "%compensation%": localizedCompensationValue })}
          </Heading>
          <Text fontSize={{ base: "md", md: "lg" }} mb={4}>
            {translations("hero_description", { "%compensation%": localizedCompensationValue })}
          </Text>
          <Button
            data-testid="hero-share-now"
            px={10}
            width={{ base: "100%", md: "initial" }}
            my={4}
            mr={{ base: 0, md: 5 }}
            onClick={clickHandler}
            title={translations("button_share_now")}
          >
            {translations("button_share_now")}
          </Button>
        </Box>
        <Flex
          gridColumn={{ base: "initial", md: "span 6", lg: "7 / span 6" }}
          alignSelf={{ base: "center", lg: "flex-end" }}
        >
          <Box pos="relative">
            <Image
              src={`${config.staticUrl}/i/referral-lp/hero-section-decoration-img_aLL3oqdHo.png?updatedAt=1627991461035`}
              alt={translations("help_a_friend_image_alt")}
            />
            <Box
              pos="absolute"
              transform={{ base: "translateX(-6%)", md: "translateX(-16%)", lg: "translateX(-27%)" }}
              top={{ base: "51%", md: "20%", lg: "20%" }}
            >
              <HeroCard content={svgContentConfig} />
            </Box>
          </Box>
        </Flex>
      </Grid>
    </Box>
  );
};

export default Hero;
